import React, {useState, useEffect} from "react";

import {
	Box,
	Button,
	IconButton,
	Tooltip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	TextField
} from '@mui/material';

import useMediaQuery from '@mui/material/useMediaQuery';

import LoadingButton from '@mui/lab/LoadingButton';

import GroupAddIcon from '@mui/icons-material/GroupAdd';

import api from '../../../api';

import '../styles.css';

import AddClientGroupForm from './AddClientGroupForm';

export default function ResponsiveCreateClientGroupButton({ parent, isDisabled, selectionIds }) {
  const isSmallScreen = useMediaQuery('(max-width: 60rem)');
  
  const [showAddFrom, updateShowAddFrom] = useState(false);

  useEffect(() => {
    updateShowAddFrom(false)
  }, [])

  return (
    <>
          <LoadingButton
            className="button-add-group-selected"
            component="label"
            onClick={() => updateShowAddFrom(true)}
            startIcon={<GroupAddIcon />}
            disabled={isDisabled}
          >
            Criar Segmento
          </LoadingButton>
          <>
          
            <AddClientGroupForm 
              selectionIds={selectionIds}
              enterpriseId={parent.enterpriseId}
              open={showAddFrom}
              handleClose={() => {updateShowAddFrom(false)}}
              parent={parent}
            />
            
          </>
    </>
  )
}
